<template>
  <div
    v-if="getContent"
    class="sticky-banner flex--row-center-center"
    :style="`background: ${getContent.backgroundColor}`"
    ref="siteBannerContainer"
  >
    <div
      class="sticky-banner__content"
      v-if="!shouldScroll"
      ref="textContainerOne"
    >
      <RichText
        class="sticky-banner__text sticky-banner__text--line-1 flex--col-center-center text-zd-banner"
        :class="{ 'sticky-banner__text--animated': !!getContent.textLine2 }"
        :style="`color: ${getContent.textColor}`"
        :content="getContent.textLine1"
      />
      <RichText
        class="sticky-banner__text sticky-banner__text--animated sticky-banner__text--line-2 flex--col-center-center text-zd-banner"
        :style="`color: ${getContent.textColor}`"
        :content="getContent.textLine2"
        v-if="getContent.textLine2"
      />
    </div>
    <!-- <MarqueeText
      class="sticky-banner__marquee"
      v-else
      :repeat="10"
      :duration="15"
      ref="textContainerTwo"
    >
      <RichText
        class="sticky-banner__text-line-1 sticky-banner__scrollable-text text-zd-banner"
        :content="getContent.textLine1"
        :style="`color: ${getContent.textColor}`"
        ref="textOne"
      />
      <RichText
        class="sticky-banner__text-line-2 sticky-banner__scrollable-text text-zd-banner"
        :content="getContent.textLine2"
        :style="`color: ${getContent.textColor}`"
        v-if="getContent.textLine2"
        ref="textTwo"
      />
    </MarqueeText> -->
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex"
import RichText from "@/components/RichText"
// import MarqueeText from "vue-marquee-text-component"
import ContentfulMixin from "../../contentfulComponents/ContentfulMixin"

export default {
  mixins: [ContentfulMixin],

  contentfulModel: "SiteBanner",

  data() {
    return {
      lastScrollPosition: 0,
      shouldScroll: false,
      maxTextSize: 0
    }
  },
  components: {
    RichText
    // MarqueeText
  },

  computed: {
    ...mapState("scroll", ["scrollPos", "autoScroll"]),
    ...mapState("breakpoints", ["currentWidth"]),
    ...mapGetters("content", ["GET_SITE_CONFIG"]),
    ...mapGetters("breakpoints", ["GET_IS_ABOVE_BREAKPOINT"])

    /* getIsScrollOptionSelected() {
      return !!this.getContent.enableScrollingText
    } */
  },

  mounted() {
    this.setMaxTextSize()
    // this.updateShouldScroll(this.currentWidth)
    // if (this.getIsScrollOptionSelected) {
    //   this.shouldScroll = true
    // }
  },

  beforeDestroy() {},
  methods: {
    ...mapMutations("scroll", ["SET_SHOW_BANNER"]),

    onScroll(currentScrollPosition) {
      if (currentScrollPosition < 0) {
        return
      }

      // Stop executing this function if the difference between
      // current scroll position and last scroll position is less than some offset
      if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 70) {
        return
      }

      this.SET_SHOW_BANNER(currentScrollPosition < this.lastScrollPosition)
      this.lastScrollPosition = currentScrollPosition
    },

    setMaxTextSize() {
      this.$refs.siteBannerContainer.style.width = "3000px"
      this.maxTextSize = this.$refs.textContainerOne.offsetWidth + 20
      this.$refs.siteBannerContainer.style.width = "100%"
    }

    // updateShouldSwitch(pageWidth) {
    //   this.shouldScroll =
    //     this.getContent.enableScrollingText ||
    //     (!this.getIsScrollOptionSelected && this.maxTextSize > pageWidth)
    // }
  },

  watch: {
    scrollPos(newVal) {
      if (!this.autoScroll) this.onScroll(newVal)
    }

    // currentWidth(newVal) {
    //   this.updateShouldScroll(newVal)
    // }
  }
}
</script>

<style lang="scss">
.sticky-banner {
  color: $bleach-black;

  height: $banner-height-default;
  width: 100%;

  position: fixed;
  transform: translateY(-$banner-height-default);
  transition: transform $banner-animation-speed $banner-animation-ease;
  z-index: 9; // Menu z-index - 1

  @include media-breakpoint-up(sm) {
    height: $banner-height-sm;
    transform: translateY(-$banner-height-sm);
  }

  @include media-breakpoint-up(md) {
    transform: translateY(-$banner-height-sm);
  }

  @include media-breakpoint-up(lg) {
    height: $banner-height-lg;
    transform: translateY(-$banner-height-lg);
  }

  .show-banner.active-banner & {
    transform: translateY(0);
  }

  &__marquee {
    height: 1.5em;

    .marquee-text-text {
      display: flex;
    }
  }

  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  &__text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    @include media-breakpoint-down(xs) {
      font-size: 1rem;
    }

    &--animated {
      animation: banner-fade-out 10s linear infinite alternate;
    }

    &--line-1 {
      // animation-delay: 5s;
      z-index: 1;
    }

    &--line-2 {
      // opacity: 0;
      animation-direction: alternate-reverse;
    }
  }

  // &__scrollable-text {
  //   margin-left: 30px;

  //   @include media-breakpoint-down(xs) {
  //     margin-left: 20px;
  //   }
  // }
}

@keyframes banner-fade-out {
  0% {
    opacity: 1;
  }

  // 1% {
  //   opacity: 1;
  // }

  48% {
    opacity: 1;
  }

  52% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
}
</style>
